import { createFileRoute } from "@tanstack/react-router";
import { Keys4SteamLanding } from "@/components/keys4steam-landing";
import { SiteBrandProvider } from "@/lib/site-brand-context";

export const Route = createFileRoute("/keys4steam-preview")({
  head: () => ({
    meta: [
      { title: "Keys4Steam Preview" },
      { name: "description", content: "Development preview of the Keys4Steam landing page." },
      { property: "og:title", content: "Keys4Steam Preview" },
      { property: "og:description", content: "Development preview of the Keys4Steam landing page." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: Keys4SteamPreviewPage,
});

function Keys4SteamPreviewPage() {
  return (
    <SiteBrandProvider brand="keys4steam">
      <div className="keys4steam min-h-screen bg-background text-foreground">
        <Keys4SteamLanding previewFallback />
      </div>
    </SiteBrandProvider>
  );
}